import { z } from 'zod';
export const warehouseSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  address: z.string().min(1, 'Address is required'),
  gstin: z.string().optional(),
});
export type WarehouseInput = z.infer<typeof warehouseSchema>;
